import React, { useCallback, useEffect } from 'react';

import { trackPage, useAnalyticsHomeownerParams } from '../../hooks/useEventTracking';
import { useOrgData } from '../../hooks/useOrgData';
import { FormattedServicesData, useServices } from '../../hooks/useServices';
import { useOnlineBookingReducer } from '../../state/useOnlineBookingReducer';
import { STEP_HASH_MAP } from '../../Steps/consts';
import { OnlineBookingUnavailable } from '../../Steps/OnlineBookingUnavailable';
import { ServiceAreaWrapper } from '../../Steps/ServiceAreaStep/ServiceAreaWrapper';
import { CompanyLogo } from '../CompanyLogo';
import { DataError } from '../DataError';
import { ListSkeleton } from '../ListSkeleton';

export const HomeOwnerFlowContent = () => {
  const { state, dispatch, actions } = useOnlineBookingReducer();
  const { token, customerBanned, stepKey } = state;
  const { data: orgData, isError: isOrgError } = useOrgData({ token });

  const onSuccess = useCallback(
    (data: FormattedServicesData) => {
      dispatch(actions.skipSteps(data));
    },
    [dispatch, actions]
  );

  const { isLoading, isFetching, isError } = useServices({ token, onSuccess });

  const selectedStep = STEP_HASH_MAP[stepKey];

  if (!selectedStep) {
    throw new Error(`Selected step ${stepKey} is out of scope!`);
  }
  let ContentComponent;

  const { component: StepComponent } = selectedStep;

  ContentComponent = StepComponent;

  if (isLoading || isFetching) {
    ContentComponent = ListSkeleton;
  }

  if (isError || isOrgError) {
    ContentComponent = DataError;
  }

  const trackingProps = useAnalyticsHomeownerParams();

  useEffect(() => {
    if (trackingProps && selectedStep && selectedStep.name !== 'categories') {
      trackPage('Online Booking - Homeowner flow', {
        ...trackingProps,
        step_name: selectedStep.name,
        path: `ob_${selectedStep.name.replace('-', '_')}`,
      });
    }
  }, [selectedStep, trackingProps]);

  if (customerBanned) {
    return <OnlineBookingUnavailable customerBanned />;
  }
  const onlineBookingUnavailable =
    orgData && !('onlineBookingEnabled' in orgData) ? false : orgData?.onlineBookingEnabled === false;

  if (onlineBookingUnavailable) {
    return <OnlineBookingUnavailable />;
  }

  return (
    <ServiceAreaWrapper>
      <CompanyLogo />
      {ContentComponent ? <ContentComponent /> : <DataError />}
    </ServiceAreaWrapper>
  );
};
